// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { CreditCardErrorCode } from '@innolab-trader/tradovate-types/src/enums/creditCardErrorCode'

export interface DeleteCreditCardRequest {
  creditCardId: number
}

export interface CreditCardResponse {
  errorText?: string
  errorCode?: CreditCardErrorCode
  creditCardId?: number
}

/**
 * Validate DeleteCreditCardRequest request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateDeleteCreditCardRequest(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateDeleteCreditCardRequest(request: DeleteCreditCardRequest): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.creditCardId === undefined || req.creditCardId === null) {
    errors.push({
      field: 'creditCardId',
      code: 'required',
      message: 'creditCardId is required'
    })
  }

  return errors
}

export const deleteCreditCardRequest = postEndpoint<DeleteCreditCardRequest, CreditCardResponse>('/user/deleteCreditCardRequest')
